<template>
  <a
    v-if="entity_status === 'deleted'"
    class="btn btn-secondary disabled px-1 py-0"
  >
    <i class="fa fa-trash mr-1" />Deleted
  </a>
  <a
    v-else-if="entity_status === 'unavailable'"
    class="btn btn-secondary disabled px-1 py-0"
  >
    <i class="fa fa-ban mr-1" />Unavailable
  </a>
  <span v-else>
    <slot name="existing-content" />
  </span>
</template>

<script>
import { getEntityData } from "@/shared/utils";

export default {
  name: "ExistenceGate",
  props: {
    entity: {
      type: Object,
      default: () => null,
    },
    levels: {
      type: Array,
      default: () => [],
    },
    field: {
      type: String,
      default: null,
    },
  },
  computed: {
    entity_status() {
      return getEntityData({
        entity: this.entity,
        levels: this.levels,
        field: this.field,
      });
    },
  },
};
</script>
